/* eslint-disable react/prop-types */
import {useState} from 'react';
import Locale from '../util/Locale';
import './DeleteFolder.scss';
import LoadingIndicator from './LoadingIndicator';

function DeleteFolder({title, parent, setShowModal, onAction}) {
    const [status, setStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const renderResult = () => {
        if (status !== null) {
            if (status === true) {
                return <div className="status alt-description">{Locale.getText('FOLDER_DELETED')}</div>;
            }
            return <div className="status alt-description">{Locale.getText('FOLDER_NOT_DELETED')}</div>;
        }
        return null;
    };

    const renderFooter = () => {
        return (
            <div className="footer-actions">
                {status === null && (
                    <nsemble-button key="CANCEL" text onClick={() => setShowModal && setShowModal(false)}>
                        {Locale.getText('CANCEL')}
                    </nsemble-button>
                )}
                {status === null && (
                    <LoadingIndicator isLoading={isLoading}>
                        <nsemble-button
                            key="DELETE"
                            destructive-text
                            onClick={async event => {
                                if (onAction) {
                                    const button = event.currentTarget;
                                    setIsLoading(true);
                                    button.disabled = true;
                                    const actionStatus = await onAction();
                                    button.disabled = false;
                                    setStatus(actionStatus);
                                    setIsLoading(false);
                                }
                            }}
                        >
                            {Locale.getText('DELETE')}
                        </nsemble-button>
                    </LoadingIndicator>
                )}
                {status !== null && (
                    <nsemble-button key="CLOSE" text onClick={() => setShowModal && setShowModal(false)}>
                        {Locale.getText('CLOSE')}
                    </nsemble-button>
                )}
            </div>
        );
    };

    const name = parent || '';
    const warning = Locale.getText('DELETE_FOLDER_WARNING', {name});

    return (
        <div>
            <div id="modal-header">
                <h1>{title}</h1>
            </div>
            <div id="modal-body">
                <div className="delete-folder">
                    <div className="delete-section">{Locale.getText('DELETE_FOLDER_MESSAGE')}</div>
                    <div className="info-block">
                        <div className="info-icon" />
                        <div className="info-text">{warning}</div>
                    </div>
                    {renderResult()}
                </div>
            </div>
            <div id="modal-footer">{renderFooter()}</div>
        </div>
    );
}

export default DeleteFolder;
